import { getBaselineDefinition, getBaselineDisplayLabel } from "./registry";
import type { BaselineRecord } from "./types";

export interface BaselineDependency {
  key: string;
  label: string;
  value: number | null;
  source: string;
  sourceLabel?: string;
  registryClass?: string;
  unit?: string;
}

/**
 * Extract c.<key> baseline references from a formula expression string.
 */
export function extractBaselineRefs(formulaExpr: string): string[] {
  const refs = new Set<string>();
  for (const match of formulaExpr.matchAll(/c\.(\w+)/g)) {
    if (match[1]) refs.add(match[1]);
  }
  return Array.from(refs);
}

/**
 * Resolve baseline dependencies for a formula.
 * Returns the baseline key, current value, source, and registry metadata.
 */
export function resolveBaselineDeps(
  formulaExpr: string,
  records: BaselineRecord[],
): BaselineDependency[] {
  const keys = extractBaselineRefs(formulaExpr);
  return keys
    .map((key) => {
      const def = getBaselineDefinition(key);
      const record = records.find((r) => r.key === key && !r.scope);
      return {
        key,
        label: getBaselineDisplayLabel(key),
        value: record?.value ?? null,
        source: record?.source ?? "absent",
        sourceLabel: record?.sourceLabel,
        registryClass: def?.class,
        unit: def?.unit,
      };
    })
    .filter((d) => d.registryClass != null && d.registryClass !== "factor");
}
